import { Link } from "wouter";
import { ChevronRight } from "lucide-react";

export type Crumb = { name: string; path: string };

interface BreadcrumbsProps {
  items: Crumb[];
  className?: string;
}

export default function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  if (items.length === 0) return null;
  const allCrumbs: Crumb[] = items[0].path === "/" ? items : [{ name: "Home", path: "/" }, ...items];

  return (
    <nav
      aria-label="Breadcrumb"
      className={`mb-6 text-sm ${className ?? ""}`}
    >
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-muted-foreground">
        {allCrumbs.map((crumb, i) => {
          const isLast = i === allCrumbs.length - 1;
          return (
            <li key={`${crumb.path}-${i}`} className="flex items-center gap-x-1.5 min-w-0">
              {isLast ? (
                <span
                  aria-current="page"
                  className="font-medium text-foreground truncate max-w-[60vw] sm:max-w-md"
                  title={crumb.name}
                >
                  {crumb.name}
                </span>
              ) : (
                <>
                  <Link
                    href={crumb.path}
                    className="hover:text-primary transition-colors"
                  >
                    {crumb.name}
                  </Link>
                  <ChevronRight className="h-3.5 w-3.5 shrink-0 text-muted-foreground/60" aria-hidden="true" />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
